import { msg } from "@omegagrid/localize";
import { NodeModel, TreeOptions, TreeSource } from "@omegagrid/tree";
import rp, { BrowserAdapter } from "@reporting/rp-app-host";import { AccountingRights } from "@reporting/rp-types/core";
;

export class AdminBrowserAdapter extends BrowserAdapter {

	async getTree(): Promise<TreeSource> {
		const items: TreeSource = [];
		// region company
		items.push({
			k: 'comp',
			v: msg('Company'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'SteelBlue', statusIcon: ['fas', 'building'], statusColor: 'Orange'},
				closedIcon: {icon: ['fas', 'folder'], color: 'SteelBlue', statusIcon: ['fas', 'building'], statusColor: 'Orange'},
			},
		}, {
			k: `accounting-accountings`,
			v: msg('Settings'),
			l: 1,
			icon: { icon: 'building', color: 'Orange' }
		});
		// the ai application is registered only when the user has the AI right, so an unguarded
		// node would resolve to the core fallback instead of the usage container
		if (rp.userProvider.hasRight(AccountingRights.AI)) {
			items.push({
				k: `ai-usageContainer`,
				v: msg('AI Usage'),
				l: 1,
				icon: { icon: 'microchip-ai', color: 'Orange' }
			});
		}
		// region users
		items.push({
			k: 'users',
			v: msg('Users'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'DarkGreen', statusIcon: ['fas', 'users'], statusColor: 'MediumSeaGreen'},
				closedIcon: {icon: ['fas', 'folder'], color: 'DarkGreen', statusIcon: ['fas', 'users'], statusColor: 'MediumSeaGreen'},
			},
		}, {
			k: `users-users`,
			v: msg('Users'),
			l: 1,
			icon: { icon: 'user', color: 'MediumSeaGreen' }
		}, {
			k: `users-userGroups`,
			v: msg('User groups'),
			l: 1,
			icon: { icon: 'users', color: 'MediumSeaGreen' }
		}, {
			k: `users-userAccessContainer`,
			v: `${msg('Access')} - ${msg('Application')}`,
			l: 1,
			icon: { icon: 'key', color: 'GoldenRod' }
		}, {
			k: `users-entityAccessContainer`,
			v: `${msg('Access')} - ${msg('Objects')}`,
			l: 1,
			icon: { icon: 'shield-check', color: 'Gray' }
		}, {
			k: `admin-securityRoles`,
			v: msg('Security roles'),
			l: 1,
			icon: { icon: 'lock-keyhole', color: 'DarkSlateBlue' }
		}, {
			k: `admin-reports`,
			v: msg('Reports'),
			l: 1,
			icon: { icon: 'files', color: 'DarkGreen' }
		});
		// region security
		items.push({
			k: 'sec',
			v: msg('Security'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'Sienna', statusIcon: ['fas', 'key'], statusColor: 'GoldenRod'},
				closedIcon: {icon: ['fas', 'folder'], color: 'Sienna', statusIcon: ['fas', 'key'], statusColor: 'GoldenRod'},
			},
		}, {
			k: `accounting-loginSettings`,
			v: msg('Login settings'),
			l: 1,
			icon: { icon: 'user-key', color: 'GoldenRod' }
		}, {
			k: `accounting-ssoSettings`,
			v: `SSO ${msg('settings')}`,
			l: 1,
			icon: { icon: 'sensor-cloud', color: 'Plum' }
		}, {
			k: `admin-accessTokens`,
			v: msg('Access Tokens'),
			l: 1,
			icon: { icon: 'key', color: 'GoldenRod' }
		}, {
			k: `admin-clientCredentials`,
			v: msg('Applications'),
			l: 1,
			icon: { icon: 'key-skeleton-left-right', color: 'DodgerBlue' }
		});
		// region synchronization
		if (rp.userProvider.hasRight([
			AccountingRights.Definition,
			AccountingRights.ETL,
			AccountingRights.MDMDefine,
			AccountingRights.CustomDefine,
			AccountingRights.WikiWrite
		])) {
			items.push({
				k: 'sync',
				v: `${msg('Synchronization')} & ${msg('Sharing')}`,
				l: 0,
				collapsed: true,
				folder: {
					openIcon: {icon: ['fas', 'folder-open'], color: 'DarkViolet', statusIcon: ['fas', 'arrows-spin'], statusColor: 'GoldenRod'},
					closedIcon: {icon: ['fas', 'folder'], color: 'DarkViolet', statusIcon: ['fas', 'arrows-spin'], statusColor: 'GoldenRod'},
				},
			});
			if (rp.userProvider.hasRight(AccountingRights.Definition)) {
					items.push({
					k: `definition-finSync`,
					v: msg('Reports'),
					l: 1,
					icon: { icon: 'files', color: 'darkgreen' }
				});
			}
			if (rp.userProvider.hasRight(AccountingRights.ETL)) {
				items.push({
					k: `etl-sync`,
					v: msg('ETL'),
					l: 1,
					icon: { icon: 'database', color: 'gainsboro' }
				});
			}
			if (rp.userProvider.hasRight(AccountingRights.MDMDefine)) {
				items.push({
					k: `mdm-sync`,
					v: msg('MDM'),
					l: 1,
					icon: { icon: 'table', color: 'cornflowerblue' }
				});
			}
			if (rp.userProvider.hasRight(AccountingRights.CustomDefine)) {
				items.push({
					k: `extensions-sync`,
					v: msg('Custom'),
					l: 1,
					icon: { icon: 'shapes', color: 'chocolate' }
				});
			}
			if (rp.userProvider.hasRight(AccountingRights.WikiWrite)) {
				items.push({
					k: `wiki-sync`,
					v: msg('Wiki'),
					l: 1,
					icon: { icon: 'book-user', color: 'SeaGreen' }
				});
			}
		}
		// region automatization
		items.push({
			k: 'auto',
			v: msg('Automatization'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'FireBrick', statusIcon: ['fas', 'robot'], statusColor: 'DarkSlateGray'},
				closedIcon: {icon: ['fas', 'folder'], color: 'FireBrick', statusIcon: ['fas', 'robot'], statusColor: 'DarkSlateGray'},
			},
		}, {
			k: `admin-emails`,
			v: msg('Emails'),
			l: 1,
			icon: { icon: 'envelopes', color: 'GoldenRod' }
		});
		// region logging
		items.push({
			k: 'log',
			v: msg('Logging'),
			l: 0,
			collapsed: true,
			folder: {
				openIcon: {icon: ['fas', 'folder-open'], color: 'ForestGreen', statusIcon: ['fas', 'rectangle-list'], statusColor: 'DarkSlateGray'},
				closedIcon: {icon: ['fas', 'folder'], color: 'ForestGreen', statusIcon: ['fas', 'rectangle-list'], statusColor: 'DarkSlateGray'},
			},
		}, {
			k: `accounting-journal`,
			v: msg('Journal'),
			l: 1,
			icon: { icon: 'reel', color: 'DarkGreen' }
		}, {
			k: `accounting-accessLog`,
			v: msg('Access log'),
			l: 1,
			icon: { icon: 'reel', color: 'DarkSlateGray', statusIcon: ['fas', 'user'], statusColor: 'MediumSeaGreen' }
		});
		return items;
	}

	getOptions(): Partial<TreeOptions> {
		return {
			selectMode: 'none',
			expanders: false,
		};
	}

	async onAction(key: string, node: NodeModel) {}
}
